import React from 'react';
import { Hero } from '../components/Hero';
import { Features } from '../components/Features';
import { HowItWorks } from '../components/HowItWorks';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-gaming-dark text-white font-sans selection:bg-gaming-cyan selection:text-gaming-dark" data-id="element-350">
      <Hero data-id="element-351" />
      <Features data-id="element-352" />
      <HowItWorks data-id="element-353" />
      <CTASection data-id="element-354" />
      <Footer data-id="element-355" />
    </div>;
}